import * as React from "react";
const SvgFiRrHrGroup = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hr-group_svg__a)">
      <path
        fill="#062147"
        d="M15 10.419v.008a5.1 5.1 0 0 0-1.36.874l-1.064.979c-.326.3-.827.3-1.153 0l-1.093-1.006A5 5 0 0 0 9 10.419 2.42 2.42 0 0 1 11.419 8h1.161a2.42 2.42 0 0 1 2.419 2.419zM8 4A2 2 0 1 0 8.001.001 2 2 0 0 0 8 4m4 3a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 7m4-3a2 2 0 1 0 .001-3.999A2 2 0 0 0 16 4m5 0a3 3 0 0 0-2.701 1.718A2.4 2.4 0 0 0 16.581 5H16a3.9 3.9 0 0 1-.401 1.717 3.48 3.48 0 0 1 1.367 2.45v.842a5 5 0 0 1 1.034.098v2.079a3 3 0 0 0-3.005.587l-3.008 2.768c-.082-.084-.16-.172-.247-.252l-2.744-2.525A2.99 2.99 0 0 0 6 12.185v-2.083q.511-.103 1.032-.1v-.815a3.48 3.48 0 0 1 1.369-2.471A3.9 3.9 0 0 1 8 4.999h-.581c-.672 0-1.28.275-1.718.718A3 3 0 0 0 3 3.999c-1.654 0-3 1.346-3 3V17.1c0 2.137.832 4.146 2.343 5.657l.95.95a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-.95-.95A5.96 5.96 0 0 1 2 17.1V7c0-.551.449-1 1-1s1 .449 1 1c0 0-.005 8.077 0 8.118.03.654.286 1.308.747 1.854l2.616 2.721a1 1 0 1 0 1.442-1.386l-2.57-2.671a1 1 0 0 1 .021-1.305.995.995 0 0 1 1.397-.086l2.734 2.516a5.01 5.01 0 0 1 1.615 3.68V23a1 1 0 0 0 2 0v-2.559a7 7 0 0 0-.824-3.276l3.163-2.911a.997.997 0 0 1 1.406.077c.16.179.474.848.066 1.255S15.28 18.22 15.28 18.22a1 1 0 1 0 1.442 1.386l2.578-2.684c.449-.535.701-.871.701-1.922V7c0-.551.449-1 1-1s1 .449 1 1v10.101a5.96 5.96 0 0 1-1.757 4.243l-.95.95a.999.999 0 1 0 1.414 1.414l.95-.95a7.95 7.95 0 0 0 2.343-5.657V7c0-1.654-1.347-3-3.001-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hr-group_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHrGroup;
